import { ExtendedAccountColumns, ExtendedAccountData } from '@/backend/features/contact-management/entities/extended-account/types';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { LayoutRows2 } from '@juvare/common-web-ui/LayoutRows2';
import { PageError } from '@juvare/common-web-ui/PageError';
import { AccountColumns, AccountData, accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import { useStorageGet } from '@juvare/platform-sdk-react/ui/hooks';
import { GetResponse } from '@juvare/platform-shared/features/storage';
import React from 'react';
import { useParams } from 'react-router';
import { RequiredInformationAccountSection, RequiredInformationDialogHeader } from './components';

export const BackgroundCheckRequiredInformationModal: React.FC = () => {
    const { accountId } = useParams<{ accountId: string }>();
    const { data: account, error } = useStorageGet<ExtendedAccountData, ExtendedAccountColumns>(accountEntityName, accountId);
    const [dialogShown, setDialogShown] = React.useState(false);

    React.useEffect(() => {
        if (!account) {
            return;
        }

        setDialogShown(true);
    }, [account]);

    React.useEffect(() => {
        if (!dialogShown || !account) return;

        showRequiredInformationDialog(account);
    }, [account, dialogShown]);

    return error ? <PageError type='not-found' error={error} /> : null;
};

const showRequiredInformationDialog = (account: GetResponse<AccountData, AccountColumns>) => {
    showCustomDialog({
        fullScreen: true,
        content: (handleClose) => (
            <LayoutRows2
                row1={<RequiredInformationDialogHeader onClose={handleClose} accountId={account.id} />}
                row2={<RequiredInformationAccountSection account={account} onClose={handleClose} />}
                fullHeightRow='row2'
                row2Scrollable
                data-test='background-check-required-information'
            />
        ),
    });
};
